export default "__VITE_ASSET__yG$rqE5Z__"